import React from "react";

const Dji = props => (
  <svg height="26.867mm" width="46.505mm" viewBox="0 0 164.781 95.198662" {...props}>
    <g transform="translate(-57.626 -906.13)">
      <g fill="#0971ce" transform="matrix(.54927 0 0 .54927 -45.604 584.42)">
        <g transform="matrix(7.1169 0 0 -7.1169 407.57 711.56)">
          <path d="m0 0 3.11 12.918h-6.676l-2.845-11.586c-0.413-2.258-2.84-3.315-4.563-3.342h-4.731l-1.605-4.657h9.941c2.452 0 6.074 1.255 7.369 6.667" fill="#0971ce"/>
        </g>
        <g transform="matrix(7.1169 0 0 -7.1169 307.84 679.14)">
          <path d="m0 0 3.138 13.131h6.87l-3.571-14.936c-0.687-2.884-2.831-3.577-4.811-3.577h-15.837c-1.745 0-3.207 0.742-2.415 4.072l1.426 5.958c0.723 3.021 2.97 3.712 4.595 3.712h11.053l-0.89-3.723h-5.643c-0.83 0-1.285-0.18-1.517-1.149l-0.91-3.803c-0.326-1.365 0.151-1.46 1.152-1.46h5.17c0.947 0 1.779 0.06 2.19 1.775" fill="#0971ce"/>
        </g>
        <g transform="matrix(7.1169 0 0 -7.1169 440.44 619.63)">
          <path d="m0 0-3.234-13.745h6.675l3.233 13.745h-6.674z" fill="#0971ce"/>
        </g>
      </g>
    </g>
  </svg>
);

export default Dji;

